import { useQueryClient, useMutation } from "@tanstack/react-query";

import { QUERY_KEYS } from "../../constants";
import api from "../../api";

const fetcher = api();

export default function useClaimBadgeMutation(options = {}) {
  const queryClient = useQueryClient();

  const {
    mutate: claimBadge,
    isLoading: isClaimBadgeLoading,
    isError: isClaimBadgeError,
    reset: resetClaimBadge,
  } = useMutation({
    mutationFn: ({ id }) => fetcher.claimBadge(id),
    onSuccess: () => {
      queryClient.invalidateQueries([QUERY_KEYS.USER]);
    },
    ...options,
  });

  return {
    claimBadge,
    isClaimBadgeLoading,
    isClaimBadgeError,
    resetClaimBadge,
  };
}
